// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"00c396fa","133":"e7340be0","345":"e2fb147d"}[chunkId] + ".chunk.css";
};